import { pushEventInfo } from '../analytics';
export var TrackBopisOosrAnalytics = function (eventName, category) {
    pushEventInfo({
        category: { primaryCategory: category },
        eventInfo: { eventName: eventName },
    });
};
export var TrackErrorEventBopisOosrAnalytics = function (pageSection, errCode, errMessage, type, // system, error, advisory
displayType) {
    if (displayType === void 0) { displayType = 'in'; }
    pushEventInfo({
        category: {
            primaryCategory: 'error',
        },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: type,
                    displayType: displayType,
                    pageSection: pageSection,
                    code: errCode,
                    message: errMessage,
                },
            ],
        },
    });
};
